module.exports = __webpack_public_path__ + "static/media/brian.de848306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/brian.jpg
// module id = 603
// module chunks = 0